export default function Contact() {
  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <h1>Contact Us</h1>
      <p>This is the Contact page. Add contact details and form here.</p>
    </div>
  );
}
